import { Network } from '@/hooks/network/useNetwork'
import { DiagnosticType } from '@/services/models/enums'
import { Interval, ParameterizationType } from '@/types/variable'

import { convertInboundArrowsToParentIds } from './general'

export const createBayesianNodesForInfer = (
  network: Network,
): BayesianNode[] => {
  // Sort variables by name to ensure consistent ordering across all API calls
  const sortedVariables = [...network.variables].sort((a, b) =>
    a.name.localeCompare(b.name),
  )

  return sortedVariables.map((v) => ({
    id: v.id,
    name: v.name,
    parameterizationType: v.parameterizationType,
    stateCount: v.stateIds.length,
    parentIds: convertInboundArrowsToParentIds(v.inboundArrows),
    probabilities: v.probabilities,
    upstreamEffectsDisabled: v.type.upstreamEffectsDisabled,
  }))
}

export type BayesianNode = {
  id: string
  name?: string
  parameterizationType: ParameterizationType
  stateCount: number
  parentIds: string[]
  probabilities: number[]
  upstreamEffectsDisabled: boolean
  // Present only on the diagnosis projection (`createBayesianNodesForDiagnosis`),
  // which is why all four are optional. `bayesianNodeSchema` has accepted them on
  // the wire since diagnosis existed; this type simply never caught up, and
  // KBE-840 needs them because the local engine reads the diagnostic roles off the
  // same projection the Diagnosis page filtered.
  faultIndices?: number[]
  diagnosticType?: DiagnosticType
  intervals?: Interval[]
  intervalUnit?: string
}
